import React from 'react'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const DOCUMENTS = [
  { icon: 'layers', title: 'Client Agreement', desc: 'The terms governing your relationship with Xperia Capital, including account opening, trading conditions, and termination.' },
  { icon: 'shield', title: 'Risk Disclosure', desc: 'A clear statement of the risks involved in trading leveraged products and automated arbitrage strategies.' },
  { icon: 'headset', title: 'Privacy Policy', desc: 'How your personal data is collected, used, and protected across the platform.' },
  { icon: 'target', title: 'AML Policy', desc: 'Our approach to anti-money-laundering checks, identity verification, and suspicious activity monitoring.' },
  { icon: 'barChart', title: 'Key Information Documents', desc: 'Product-level summaries covering costs, risk, and performance scenarios for each account type.' },
]

export default function Legal() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xlg-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 16px; }
      `}</style>
      <PublicNav active="Company" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Trust</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>Legal Documents & Disclosures</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '600px', margin: '0 auto' }}>
          The formal documents governing your use of Xperia Capital.
        </p>
      </section>

      <section style={{ padding: '64px 24px', maxWidth: '900px', margin: '0 auto' }}>
        <div className="xlg-grid">
          {DOCUMENTS.map(d => (
            <div key={d.title} style={{ background: C.light, border: `1px solid ${C.bdr}`, borderRadius: '14px', padding: '20px' }}>
              <div style={{ color: C.primary, marginBottom: '12px' }}><Icon name={d.icon} size={26} strokeWidth={1.5} /></div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '17px', color: C.tx, marginBottom: '6px' }}>{d.title}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{d.desc}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '32px', padding: '20px', background: 'rgba(247,147,26,0.06)', border: `1px solid rgba(247,147,26,0.2)`, borderRadius: '12px' }}>
          <p style={{ fontSize: '13px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>
            Full text for these documents is being finalised with legal counsel and will be published here. If you need a specific document before then, contact support from your dashboard.
          </p>
        </div>
      </section>

      <section style={{ padding: '64px 24px', borderTop: `1px solid ${C.bdr}`, background: C.light, textAlign: 'center' }}>
        <p style={{ fontSize: '14px', fontWeight: 500, color: C.tx3, maxWidth: '600px', margin: '0 auto' }}>
          Trading involves a high level of risk and may result in losses exceeding your initial deposit. Please read our full Risk Disclosure once published before subscribing to any tier.
        </p>
      </section>

      <PublicFooter />
    </div>
  )
}
